<template>
  <div class="details clearfix">
    <div
      class="detail-left"
      data-test="title"
    >
      <h4>{{ title }}</h4>
    </div>
    <div class="detail-right">
      <slot>
        <job-preview-content
          :comment-highlights="commentHighlights"
          :text-count-mode="textCountMode"
          :highlight-mode="highlightMode"
          :text-counts="textCounts"
          :target-id="targetId"
          :value="value"
          v-on="$listeners"
        >
          <template #supplement>
            <slot name="supplement" />
          </template>
          <template #sub>
            <slot name="sub" />
          </template>
        </job-preview-content>
      </slot>
    </div>
  </div>
</template>

<style scoped lang="scss">
@use "@/styles/preview/pc/offer/base" as *;
</style>

<script>
import JobPreviewContent from '@/components/atoms/JobPreviewContent'

export default {
  components: {
    JobPreviewContent
  },
  props: {
    commentHighlights: {
      type: Array,
      default: () => []
    },
    highlightMode: {
      type: Boolean,
      default: false
    },
    textCountMode: {
      type: Boolean,
      default: false
    },
    textCounts: {
      type: Array,
      default: () => []
    },
    targetId: {
      type: String,
      default: null
    },
    value: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      required: true
    }
  }
}
</script>
